import axios from "axios";

export const enviarCorreo = async (entidad) => {


    let data = JSON.stringify(entidad);

    let config = {
        method: 'post',
        maxBodyLength: Infinity,
      //  url: 'https://ingenieria-n8n.iotr9n.easypanel.host/webhook-test/5bbc4318-65ef-4355-9877-c982e259ff60', //test
        url: 'https://ingenieria-n8n.iotr9n.easypanel.host/webhook/5bbc4318-65ef-4355-9877-c982e259ff60',
        headers: {
            'Content-Type': 'application/json'
        },
        data: data
    };

    axios.request(config)
        .then((response) => {
            console.log(JSON.stringify(response.data));
        })
        .catch((error) => {
            console.log(error);
        });


}